define(["require", "exports", "three", "./Controller", "./LevelBuilder", "./Ball", "./Player"], function (require, exports, THREE, Controller_1, LevelBuilder_1, Ball_1, Player_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    class Game {
        constructor() {
            this.ballSize = 1;
            this.halfGameBoardSize = new THREE.Vector2(30, 40);
            this.render = () => {
                requestAnimationFrame(this.render);
                let delta = this.clock.getDelta();
                if (!this.ready)
                    return;
                this.update(delta);
                this.renderer.render(this.scene, this.camera);
            };
            this.renderer = new THREE.WebGLRenderer();
            this.renderer.autoClearColor = true;
            this.renderer.setClearColor(new THREE.Color(0x303030));
            this.renderer.setPixelRatio(window.devicePixelRatio);
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            document.body.appendChild(this.renderer.domElement);
            window.addEventListener('resize', this.onResize.bind(this), false);
            this.clock = new THREE.Clock();
            this.controller = new Controller_1.Controller();
            this.scene = new THREE.Scene();
            // Create a camera
            this.camera = new THREE.PerspectiveCamera(50, window.innerWidth / window.innerHeight, 0.1, 1000);
            this.camera.position.set(0, 30, 60);
            this.camera.lookAt(new THREE.Vector3(0, 0, 0));
            this.scene.add(this.camera);
            // Create the level
            this.level = new THREE.Group();
            LevelBuilder_1.LevelBuilder.build(this.level, new THREE.Vector2(50, 60), new THREE.Vector2(16, 15));
            this.scene.add(this.level);
            // Create the ball
            this.ball = new Ball_1.Ball(1);
            this.scene.add(this.ball);
            // Create the paddle
            this.player = new Player_1.Player();
            this.player.position.setZ(28);
            this.level.add(this.player);
            var loader = new THREE.FontLoader();
            loader.load('fonts/Womby_Regular.json', response => {
                this.createText(response);
            });
            // Scene is read and can be rendered
            this.ready = true;
        }
        createText(font) {
            var titleGeometry = new THREE.TextGeometry("PIT Hackathon 2017", {
                font: font,
                size: 7,
                height: 4
            });
            var titleMaterial = new THREE.MeshPhongMaterial({ color: 0xFFFFFF });
            var title = new THREE.Mesh(titleGeometry, titleMaterial);
            titleGeometry.computeBoundingBox();
            var centerOffset = -0.5 * (titleGeometry.boundingBox.max.x - titleGeometry.boundingBox.min.x);
            title.position.set(centerOffset, 4, -35);
            this.scene.add(title);
        }
        update(deltaTime) {
            if (!this.ready)
                return;
            this.player.update(deltaTime, this.controller);
            this.ball.update(deltaTime, this.level, this.player);
            // Is ball outside of the game area?
            if (this.ball.position.z > 45) {
                this.ball.init();
            }
        }
        onResize() {
            this.renderer.setSize(window.innerWidth, window.innerHeight);
            this.camera.aspect = window.innerWidth / window.innerHeight;
            this.camera.updateProjectionMatrix();
        }
    }
    exports.Game = Game;
    var game = new Game();
    game.render();
    console.log("Started");
});



//////////////////
// WEBPACK FOOTER
// ./src/Game.ts
// module id = 2
// module chunks = 0